import { useState } from 'react';
import { Button } from 'components/ui/button';
import { ArrowLeftIcon, LoaderIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
import SaveImageModal from '../components/modals/SaveImageModal';
import { useImageEditorStore } from 'components/ImageEditor/ImageEditorStoreProvider';
import { AllStoreType } from 'components/ImageEditor/store/imageEditor.type';

export default function GeneratedImageResult() {
  const [exporting, setExporting] = useState(false);
  const { imageUrl } = useImageEditorStore<AllStoreType>((state) => state);

  const handleExport = async () => {
    setExporting(true);
    
    try {
      // Handle both data URLs and regular URLs
      let blob;
      if (typeof imageUrl === 'string') {
        // Convert data URL to blob
        const response = await fetch(imageUrl);
        blob = await response.blob();
      } else if (imageUrl instanceof File) {
        // Fetch image from URL
        if (!imageUrl) return;

        const response = await fetch(imageUrl as any);
        blob = await response.blob();
      }

      // Create download URL
      const downloadUrl = window.URL.createObjectURL(blob as any);

      // Create download link
      const link = document.createElement('a');
      link.href = downloadUrl;
      link.download = 'generated-image.png';

      // Trigger download
      document.body.appendChild(link);
      link.click();

      // Cleanup
      document.body.removeChild(link);
      window.URL.revokeObjectURL(downloadUrl);
    } catch (error) {
      console.error('Error downloading image:', error);
    } finally {
      setExporting(false);
    }
  };

  return (
    <div className="col-span-12 lg:col-span-12 h-full gap-4 w-full">
      <div className="bg-background text-text-primary h-full w-full overflow-auto rounded-md">
        <div className="w-full p-3 px-4 border-b flex items-center gap-2">
          <Link
            to={'/object-remover/get-started'}
            className="flex items-center gap-3"
          >
            <ArrowLeftIcon color="#846CEC" size={20} />
          </Link>
          <div className="flex items-center gap-2 text-xs lg:text-2xl">
            <p className="font-medium ">Object Remover</p>
          </div>

          <div className="hidden lg:flex items-center gap-4 ml-auto">
            <Button
              variant={'customSecondary'}
              size={'sm'}
              className="bg-secondary"
              onClick={handleExport}
              disabled={exporting}
            >
              {exporting && (
                <div className="animate-spin">
                  <LoaderIcon size={20} />
                </div>
              )}
              {exporting ? 'Exporting...' : 'Export'}
            </Button>
            <SaveImageModal />
          </div>
        </div>

        <div className="min-h-[200px] p-4 lg:p-12 w-full flex items-center justify-center">
          <div className="max-w-full max-h-full flex items-center justify-center">
            {imageUrl && (
              <img 
                src={typeof imageUrl === 'string' ? imageUrl : URL.createObjectURL(imageUrl)}
                alt="Current image"
                className="max-w-full max-h-[70vh] object-contain rounded-md shadow-md"
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
